import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Plugin } from "types/generated";

const PluginsTableNameCell = ({ item: plugin, ...cellProps }: TableSimpleCellProps<Plugin>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellText>{plugin.name}</TableCellText>
    </TableSimpleCell>
  );
};

export default PluginsTableNameCell;
